export default __webpack_public_path__ + "static/media/doll.0f80b0f1.ogg";